/**
 * La puerta de los enlaces que llegan de afuera: `/ir/:negocio/*` (3-nov-2026).
 *
 * Un aviso de WhatsApp apunta a un chat de UN negocio, pero el panel abre todo con el negocio ACTIVO. El founder tenía
 * activo Smarty HQ, tocó el aviso de Dulti y cayó en «Conecta WhatsApp a tu negocio», como si Dulti no tuviera WhatsApp.
 * Por acá se entra al negocio del enlace y recién entonces se abre lo que pide.
 *
 * 🪤 NO VA EN `StoreGuard`. El selector de negocios cambia el activo y deja la URL con la tienda anterior; es `StoreGuard`
 *    el que, al ver que no coinciden, lo lleva al tablero del negocio nuevo. Si ese guardia cambiara al negocio de la URL,
 *    el selector volvería siempre al negocio del que se quiso salir.
 *
 * Sin acceso a ese negocio se entra al tablero propio, igual que con cualquier otra tienda ajena en la URL.
 */
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '@smarty/shared';
import { storePath } from '@/config/routes.config';
import { RedirectLoading } from '@/components/RedirectLoading';

export function EntrarAlNegocio() {
  const { negocio = '', '*': resto = '' } = useParams();
  const { search, hash } = useLocation();
  const navigate = useNavigate();
  const { loading, storeSlug, tenants, switchTenant, refreshTenants } = useAuth();
  // La lista de negocios llega después de la sesión: que todavía no esté no quiere decir que no tenga acceso.
  const [listaAlDia, setListaAlDia] = useState(false);
  const pidioLaLista = useRef(false);
  const cambioDeNegocio = useRef(false);

  useEffect(() => {
    if (loading || !storeSlug) return;
    if (storeSlug === negocio) {
      navigate(`${storePath(negocio, resto)}${search}${hash}`, { replace: true });
      return;
    }
    const destino = tenants.find((t) => t.slug === negocio);
    if (destino) {
      if (cambioDeNegocio.current) return;
      cambioDeNegocio.current = true;
      // Al cambiar, `storeSlug` pasa a ser el del enlace y este mismo efecto abre lo que pidió.
      switchTenant(destino.id).catch(() => navigate(storePath(storeSlug, ''), { replace: true }));
      return;
    }
    if (listaAlDia) {
      navigate(storePath(storeSlug, ''), { replace: true });
      return;
    }
    if (pidioLaLista.current) return;
    pidioLaLista.current = true;
    void refreshTenants().finally(() => setListaAlDia(true));
  }, [loading, storeSlug, negocio, resto, search, hash, tenants, listaAlDia, navigate, switchTenant, refreshTenants]);

  return <RedirectLoading />;
}
